import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance';
import Alert from '../components/Alert';

const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // CHANGED: State for creating now includes sequence
  const [newCategoryName, setNewCategoryName] = useState('');
  const [newCategorySequence, setNewCategorySequence] = useState(0);
 
  const [editingCategory, setEditingCategory] = useState({ id: null, name: '', sequence: 0 });


  const [alert, setAlert] = useState({ message: null, type: 'success', });

  // Function to show a success alert
  const showSuccessAlert = (message) => {
    setAlert({  message, type: 'success',  });
  };

  // Function to show an error alert
  const showErrorAlert = (message) => {
    setAlert({  message, type: 'error',  });
  };

  // Function to close/hide the alert
  const handleCloseAlert = () => {
    setAlert({ message: null });
  };


  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/categories');
      setCategories(response.data);
      setError(null);
    } catch (err) {
      setError('Failed to fetch categories.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [alert]);

  const handleCreateCategory = async (e) => {
    e.preventDefault();
    if (!newCategoryName.trim()) return;

    try {
      // CHANGED: Send sequence in the request body
      await axiosInstance.post('/categories', { name: newCategoryName, sequence: newCategorySequence });
      setNewCategoryName('');
      setNewCategorySequence(0); // Reset sequence input
      fetchCategories();
    } catch (err) {
      setError('Failed to create category. It may already exist.');
    }
  };

  const handleUpdateCategory = async (id) => {
    if (!editingCategory.name.trim()) return;
    
    try {
      // CHANGED: Send sequence in the request body
      const payload = { name: editingCategory.name, sequence: editingCategory.sequence };
      await axiosInstance.put(`/categories/${id}`, payload);
      setEditingCategory({ id: null, name: '', sequence: 0 });
      fetchCategories();
    } catch (err) {
      setError('Failed to update category.');
    }
  };

  const handleDeleteCategory = async (id) => {
  // 1. Confirm the action to prevent accidental deletion
  if (!window.confirm("Are you sure you want to delete this category? This action cannot be undone.")) {
    return; // Stop the function if the user cancels
  }

  try {
    // const response = await fetch(`/api/categories/${id}`, {
    const response = await axiosInstance.delete(`/categories/${id}`);
    console.log("Response", response)
   showSuccessAlert("Category deleted successfully!")
  
  } catch (error) {
    // 5. Handle network errors or other exceptions during the fetch call
    console.error('An error occurred while deleting the category:', error);
    showErrorAlert(error.response.data.message || "Error in delete! Try Later.")
  }
};
  if (loading) return <p>Loading categories...</p>;

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Manage Categories</h2>

<Alert
        message={alert.message}
        type={alert.type}
        onClose={handleCloseAlert}
      />
      {/* CHANGED: Create Category Form now has a sequence input */}
      <form onSubmit={handleCreateCategory} className="flex items-end gap-2 mb-6">
        <div className="flex-grow">
          <label className="block text-sm font-medium text-gray-700">Category Name</label>
          <input
            type="text"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            placeholder="New category name"
            className="mt-1 w-full p-2 border border-gray-300 rounded"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Sequence</label>
          <input
            type="number"
            value={newCategorySequence}
            onChange={(e) => setNewCategorySequence(Number(e.target.value))}
            className="mt-1 w-24 p-2 border border-gray-300 rounded"
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600">
          Add Category
        </button>
      </form>

      <ul className="space-y-3">
        {categories.map((category) => (
          <li key={category.id} className="flex items-center justify-between p-3 bg-gray-50 rounded border">
            {editingCategory.id === category.id ? (
              // --- CHANGED: EDITING VIEW now has a sequence input ---
              <div className="flex-grow flex items-center gap-2">
                <input
                  type="text"
                  value={editingCategory.name}
                  onChange={(e) => setEditingCategory({ ...editingCategory, name: e.target.value })}
                  className="flex-grow p-2 border border-blue-500 rounded"
                />
                <input
                  type="number"
                  value={editingCategory.sequence}
                  onChange={(e) => setEditingCategory({ ...editingCategory, sequence: Number(e.target.value) })}
                  className="w-24 p-2 border border-blue-500 rounded"
                />
                <button onClick={() => handleUpdateCategory(category.id)} className="bg-green-500 text-white py-1 px-3 rounded text-sm">Save</button>
                <button onClick={() => setEditingCategory({ id: null, name: '' })} className="bg-gray-400 text-white py-1 px-3 rounded text-sm">Cancel</button>
              </div>
            ) : (
              // --- DEFAULT VIEW ---
              <>
                <div className="flex items-center gap-4">
                  <span className="text-gray-500 text-sm font-mono w-8 text-center">{category.sequence}</span>
                  <span className="text-gray-800">{category.name}</span>
                </div>
                <div className="space-x-2">
                  <button onClick={() => setEditingCategory({ id: category.id, name: category.name, sequence: category.sequence })} className="text-blue-500 hover:underline text-sm">
                    Edit
                  </button>
                  <button onClick={() => handleDeleteCategory(category.id)} className="text-red-500 hover:underline text-sm">
                    Delete
                  </button>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryManager;